/**
 * La Coochie Content Collective application form (sections/lc-apply-form.liquid).
 * Submit POSTs the fields form-encoded (plus the page URL) to the Google Apps Script URL in the section settings
 * as a CORS request and treats anything but a 2xx (after Apps Script's redirect to googleusercontent) as a failure —
 * verified 2026-09-06: the deployed script answers 200 "OK". Without a URL the form opens a prefilled mailto: to
 * the fallback address. Success swaps the form for
 * the status panel and moves focus to its heading; a network failure shows the error message and keeps the form.
 */
import { Component } from '@theme/component';

class LcApplyForm extends Component {
  requiredRefs = ['form', 'success'];

  /** @param {SubmitEvent} event */
  async submit(event) {
    event.preventDefault();
    const { form, success, error, successHeading } = this.refs;
    if (!(form instanceof HTMLFormElement)) return;
    const { webhook = '', mailto = '', subject = '' } = form.dataset;

    const url = form.querySelector('input[type="url"]');
    if (url instanceof HTMLInputElement && url.value && !/^https?:\/\//i.test(url.value)) {
      url.value = `https://${url.value}`;
    }

    /** @type {[string, string][]} */
    const entries = [...new FormData(form)].map(([key, value]) => [key, String(value)]);

    if (!webhook) {
      const body = entries.map(([key, value]) => `${key}: ${value}`).join('\n');
      location.href = `mailto:${mailto}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      return;
    }

    const data = new URLSearchParams(entries);
    data.append('page_url', location.href);
    const button = form.querySelector('[type="submit"]');
    if (button instanceof HTMLButtonElement) button.disabled = true;
    if (error instanceof HTMLElement) error.hidden = true;

    try {
      const response = await fetch(webhook, { method: 'POST', mode: 'cors', redirect: 'follow', body: data });
      if (!response.ok) throw new Error(`Apps Script responded ${response.status}`);
      form.hidden = true;
      if (success instanceof HTMLElement) success.hidden = false;
      if (successHeading instanceof HTMLElement) successHeading.focus();
    } catch (err) {
      console.error('[lc-apply-form]', err);
      if (error instanceof HTMLElement) error.hidden = false;
      if (button instanceof HTMLButtonElement) button.disabled = false;
    }
  }
}

if (!customElements.get('lc-apply-form')) {
  customElements.define('lc-apply-form', LcApplyForm);
}
